export default `Canny('identify', {
  appID: 'YOUR_APP_ID',
  user: {
    avatarURL: viewer.avatarURL, // optional
    created: new Date(viewer.created).toISOString(), // optional
    email: viewer.email,
    id: viewer.id,
    name: viewer.name,
  },
  authenticateLinks: false,
});`;
